/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect, ChangeEvent } from 'react';
import { FormikHelpers, FormikProvider, useFormik } from 'formik';
import Swal from 'sweetalert2';
import Divider from '@mui/material/Divider';
import _ from 'lodash';

// icons
import { ReactComponent as Archive } from 'design_system/src/static/icons/archive.svg';
import { ReactComponent as Image } from 'design_system/src/static/icons/image.svg';
import { ReactComponent as Save } from 'design_system/src/static/icons/save.svg';
import { ReactComponent as Close } from 'design_system/src/static/icons/close-circle.svg';
import { ReactComponent as Search } from 'design_system/src/static/icons/search.svg';
import { ReactComponent as Position } from 'design_system/src/static/icons/gps.svg';
import { ReactComponent as Right } from 'design_system/src/static/icons/right-md.svg';

import { ReactComponent as Play } from 'design_system/src/static/icons/play-circle.svg';
import { ReactComponent as Pause } from 'design_system/src/static/icons/pause-circle.svg';

import { Button, Input, Typography, SideModal } from 'design_system/src';

// css
import { toasterOptions } from 'models/shared/enums/toaster.enum';
import { imagesDto } from 'models/inventory/interfaces/vehicle.interface';
import { toasterNotification } from 'models/shared/helpers/toasterNotification';
import { filterObjectByKeys } from 'models/shared/helpers/utils';
import {
	CreateExternalVehicleDto,
	ExternalVehicle,
	UpdateExternalVehicleDto,
} from 'models/_external/external-vehicles/interfaces/external-vehicles.interface';
import {
	createExternalVehicle,
	updateExternalVehicle,
} from 'models/_external/external-vehicles/controllers/external-vehicles.controller';
import {
	fetchGeotile,
	fetchGeotiles,
	syncGeotiles,
} from 'models/_external/geotile/controllers/geotile.controller';
import { commonErrorHandler } from 'models/shared/helpers/errors';
import { Geotile } from 'models/_external/geotile/interfaces/geotile.interface';
import { ExternalVehicleStatusEnum } from 'models/_external/external-vehicles/enums/external-vehicles.enum';
import {
	externalVehicleDefaults,
	externalVehicleValidationSchema,
} from './constants';

interface EditProps {
	open: boolean;
	setOpen: Function;
	values?: Partial<ExternalVehicle> | null;
	setResult: Function;
}

function EditExternalVehicle({
	open,
	setOpen,
	values = null,
	setResult,
}: EditProps) {
	const [img, setImg] = useState<imagesDto>();
	const [tile, setTile] = useState<Geotile>();
	const [availableTiles, setAvailableTiles] = useState<Geotile[]>([]);
	const [loadingTiles, setLoadingTiles] = useState(false);
	const [initial, setInitial] = useState<
		UpdateExternalVehicleDto | CreateExternalVehicleDto
	>(externalVehicleDefaults);
	const [modified, setModified] = useState<boolean>(false);
	const [showErrors, setShowErrors] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);

	const [fullOpen, setFullOpen] = useState<boolean>(false);
	const [query, setQuery] = useState();

	useEffect(() => {
		requestGeotiles();
	}, []);

	const requestGeotiles = () => {
		setLoadingTiles(true);
		fetchGeotiles({
			isAssigned: false,
			query: query ?? undefined,
		})
			.then((tiles) => {
				setLoadingTiles(false);
				setAvailableTiles(tiles.data);
			})
			.catch((e) => {
				commonErrorHandler(e);
				setLoadingTiles(false);
			});
	};

	useEffect(() => {
		let initialValue = externalVehicleDefaults;
		if (values?._id) {
			const imgs = values.image
				? {
						view: values.image.url,
						name: values.image.name,
				  }
				: undefined;
			setImg(imgs);

			setTile(values.tile);

			initialValue = filterObjectByKeys(
				values,
				Object.keys(externalVehicleDefaults) as any,
			);
		}

		setInitial(initialValue);
	}, [values]);

	const handleFiles = (e: ChangeEvent<HTMLInputElement>) => {
		const { files } = e.target;
		if (files) {
			const file = files.item(0);
			// eslint-disable-next-line no-plusplus
			if (file) {
				if (file.size > 10000000) {
					Swal.fire({
						text: 'La imagen no debe ser superior a 10mb',
						icon: 'warning',
						confirmButtonText: 'Aceptar',
					});
				} else {
					setImg({
						file,
						view: URL.createObjectURL(file),
					});
					setModified(true);
				}
			}
		}
	};

	const displayFormErrors = (form: any) => {
		if (Object.keys(form.errors)?.length)
			toasterNotification({
				msg: `Hay errores en los campos: ${Object.keys(form.errors).reduce(
					(acc, ele) => `${acc ? `${acc}, ` : ''}'${ele}'`,
					'',
				)}`,
				style: 'light',
				toasterType: toasterOptions.error,
			});
		setShowErrors(true);
	};

	const displayRequestErrors = (err: any) => {
		if (err.message === 'Vehicle already exists') {
			// eslint-disable-next-line no-param-reassign
			err =
				'Este internalId ya existe, si es una moto recuperada marque la anterior como tal para registrar la nueva moto';
		}
		toasterNotification({
			msg:
				typeof err === 'string'
					? err
					: typeof err.message === 'string'
					? err.message
					: 'Ocurrio un error',
			toasterType: toasterOptions.error,
			style: 'light',
		});
		setLoading(false);
	};

	const onSubmit = (
		vals: UpdateExternalVehicleDto | CreateExternalVehicleDto,
		form: FormikHelpers<UpdateExternalVehicleDto | CreateExternalVehicleDto>,
	) => {
		setLoading(true);

		if (values?._id) {
			const payload = { ...vals };
			if (values.tile?._id !== tile?._id) payload.tile = tile?._id;
			updateExternalVehicle(payload, values._id, img)
				.then((ele) => {
					setLoading(false);
					setOpen(false);
					setResult(ele);
				})
				.catch((err) => {
					displayRequestErrors(err);
				});
		} else {
			createExternalVehicle(
				{ ...vals, tile: tile?._id } as CreateExternalVehicleDto,
				img,
			)
				.then((ele) => {
					setLoading(false);
					setOpen(false);
					setResult(ele);
				})
				.catch((err) => {
					displayRequestErrors(err);
				});
		}
	};
	const changeVehicleStatus = () => {
		setLoading(true);

		if (values?._id) {
			updateExternalVehicle(
				{
					status:
						values.status === ExternalVehicleStatusEnum.active
							? ExternalVehicleStatusEnum.inactive
							: ExternalVehicleStatusEnum.active,
				},
				values._id,
				img,
			)
				.then((ele) => {
					setLoading(false);
					setOpen(false);
					setResult(ele);
				})
				.catch((err) => {
					displayRequestErrors(err);
				});
		}
	};

	const sincronizarTile = () => {
		setLoadingTiles(true);
		syncGeotiles()
			.then((ele) => {
				toasterNotification({
					msg: `Se han agregado ${ele.created} GPSs`,
					toasterType: toasterOptions.success,
					style: 'light',
				});
				requestGeotiles();
			})
			.catch((e) => {
				setLoadingTiles(false);
				commonErrorHandler(e);
			});
	};

	const form = useFormik<UpdateExternalVehicleDto | CreateExternalVehicleDto>({
		initialValues: initial,
		validationSchema: externalVehicleValidationSchema,
		onSubmit,
		enableReinitialize: true,
		validateOnMount: true,
	});

	return (
		initial && (
			<SideModal
				open={open}
				setOpen={setOpen}
				fullOpen={fullOpen}
				setFullOpen={setFullOpen}
			>
				<FormikProvider value={form}>
					<div className="flex_header">
						<Typography
							scale="heading4"
							weight="600"
							textColor="neutral_900"
							className="m_b_lg m_t_md"
						>
							{values?._id ? 'Editar Vehiculo' : 'Crear nuevo Vehiculo'}
						</Typography>
						<Divider />
					</div>
					<div className="flex_body p_y_lg p_x_sm overflow_x_hidden">
						<div className="flex_center">
							{img ? (
								<div className="dso_card bg_neutral_0 flex_center_col m_b_xl p_md pos_relative">
									<Close
										className="text_red_300 dim_lg delete_photo"
										onClick={() => {
											setImg(undefined);
										}}
									/>
									<Typography
										scale="xsmall"
										weight="600"
										textColor="neutral_900"
										className="text_center m_b_md"
									>
										FOTO
									</Typography>
									<div
										className="dso_card_img m_b_md bg_neutral_200 w_fit display_flex overflow_hidden"
										onClick={() => 1}
										onKeyPress={() => 1}
										role="button"
										tabIndex={0}
									>
										<img src={img.view} alt="" className="cards_photo " />
									</div>
								</div>
							) : (
								<div className="dso_card bg_neutral_0 flex_center_col m_b_xl m_r_md p_md border_primary_200 border_dotted pos_relative ">
									<Typography
										scale="xsmall"
										weight="600"
										textColor="primary_300"
										className="text_center m_b_md"
									>
										AÑADIR FOTO
									</Typography>
									<div
										className="dso_card_img m_b_md bg_neutral_200 w_fit display_flex overflow_hidden border_primary_300"
										onClick={() => 1}
										onKeyPress={() => 1}
										role="button"
										tabIndex={0}
									>
										<Image className="dim_xl m_lg text_primary_300 border_transparent" />
										<input
											type="file"
											multiple
											accept="image/png, image/jpeg"
											onChange={handleFiles}
											className="input-file"
										/>
									</div>
								</div>
							)}
						</div>
						<Input
							onBlur={form.handleBlur}
							error={
								!!form.errors.internalId &&
								(form.getFieldMeta('internalId').touched || showErrors)
							}
							subtitle={
								form.getFieldMeta('internalId').touched || showErrors
									? (form.errors.internalId as string | undefined)
									: undefined
							}
							title="Identificador unico"
							icon={<Archive />}
							placeholder="Identificacion vehículo"
							name="internalId"
							type="text"
							className="m_b_xs w_100_per"
							value={form.values.internalId}
							onChange={(e: any) => {
								form.handleChange(e);
							}}
						/>
						<Input
							onBlur={form.handleBlur}
							error={
								!!form.errors.description &&
								(form.getFieldMeta('description').touched || showErrors)
							}
							subtitle={
								form.getFieldMeta('description').touched || showErrors
									? form.errors.description
									: undefined
							}
							placeholder="Descripcion"
							title="Descripción"
							icon={<Archive />}
							name="description"
							type="text"
							className="m_b_xs w_100_per"
							value={form.values.description}
							onChange={form.handleChange}
						/>
						<div
							className="br_xs border_1 border_solid border_neutral_400 p_md display_flex flex_gap_md flex_align_center m_t_xl cursor_pointer"
							role="button"
							onClick={() => {
								setFullOpen(true);
							}}
							onKeyDown={() => {
								setFullOpen(true);
							}}
							tabIndex={0}
						>
							<Position className="dim_md" />

							<Typography scale="medium" weight="400" className="flex_1">
								{tile ? `GPS: ${tile.name}` : 'Asignar GPS'}
							</Typography>
							<Right className="dim_md" />
						</div>
					</div>
					<div className="flex_footer">
						{values?._id ? (
							<Button
								scale="small"
								orientation="right"
								icon={
									values.status === ExternalVehicleStatusEnum.active ? (
										<Pause />
									) : (
										<Play />
									)
								}
								className="m_b_md w_100_per"
								color={
									values.status === ExternalVehicleStatusEnum.active
										? 'red'
										: 'green'
								}
								type="submit"
								onClick={() => {
									changeVehicleStatus();
								}}
								disabled={loading}
							>
								{values.status === ExternalVehicleStatusEnum.active
									? 'Desactivar'
									: 'Reactivar'}{' '}
								Vehiculo
							</Button>
						) : null}
						<Button
							scale="small"
							orientation="right"
							icon={<Save />}
							className="m_b_xs w_100_per"
							type="submit"
							onClick={() => {
								displayFormErrors(form);
								form.handleSubmit();
							}}
							disabled={loading || (!form.dirty && !modified)}
						>
							Guardar
						</Button>
					</div>
				</FormikProvider>
				<div>
					<div className="flex_header">
						<Typography
							scale="heading4"
							weight="600"
							textColor="neutral_900"
							className="m_b_lg m_t_md"
						>
							Seleccionar GPS
						</Typography>
						<Divider />
						<div className="display_flex flex_gap_md w_100_per flex_align_center">
							<Input
								title=""
								placeholder="Búsqueda"
								className="flex_1"
								name="search"
								type="text"
								value={query}
								onChange={(e: any) => setQuery(e.target.value)}
							/>
							<Button
								type="submit"
								scale="small"
								icon={<Search />}
								className=""
								onClick={requestGeotiles}
								variant="icon"
								subvariant="fill"
							/>
						</div>
					</div>
					<div className="flex_body p_r_xs overflow_x_hidden">
						{loadingTiles ? (
							<Typography scale="medium" weight="400" textColor="neutral_900">
								Cargando Dispositivos
							</Typography>
						) : availableTiles?.length ? (
							<div className="display_flex flex_col flex_gap_xs">
								{availableTiles.map((dev) => (
									<div
										className="br_xs border_1 border_solid border_neutral_400 p_md display_flex flex_gap_md flex_align_center cursor_pointer"
										key={dev._id}
										role="button"
										onClick={() => {
											setFullOpen(false);
											setQuery(undefined);
											setTile(dev);
											setModified(true);
										}}
										onKeyDown={() => {
											setFullOpen(false);
											setQuery(undefined);
											setTile(dev);
											setModified(true);
										}}
										tabIndex={0}
									>
										<Position className="dim_md" />
										<Typography scale="medium" weight="400" className="">
											Nombre: {dev.name ?? '--'}
										</Typography>
									</div>
								))}
							</div>
						) : (
							<div className="flex_center flex_col flex_gap_md">
								<Typography scale="medium" weight="400" textColor="neutral_900">
									No se encontraron dispositivos, si se registraron nuevos,
									porfavor sincronizalos
								</Typography>
								<Button
									scale="small"
									onClick={() => {
										sincronizarTile();
									}}
									disabled={loadingTiles}
								>
									Sincronizar GPS
								</Button>
							</div>
						)}
					</div>
				</div>
			</SideModal>
		)
	);
}

export default EditExternalVehicle;
